import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { User } from '@triare/auth-redux/dist/saga/auth/useMe';
import { actions } from './index';

export interface UserByIdGetParams {
  id: string;
}

export const userById = (payload: UserByIdGetParams): Action<UserByIdGetParams> => ({
  type: actions.userByIdTrigger.toString(),
  payload,
});

export const userByIdClear = (): Action => ({
  type: actions.userByIdClear.toString(),
});

export const userByIdErrorClear = (): Action => ({
  type: actions.userByIdErrorReset.toString(),
});

export function* userByIdRequestSaga({ payload }: Action<UserByIdGetParams>) {
  yield put({
    type: actions.userByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userByIdError.toString(),
      payload: {
        message: 'UserById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<User, User>(
    response,
    actions.userByIdSuccess.toString(),
    actions.userByIdError.toString(),
    false,
    (userByIdData) => userByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userByIdTrigger.toString(),
    defaultProcessingSaga(
      userByIdRequestSaga,
      {
        error: actions.userByIdError.toString(),
        locationCancel: actions.userByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.userByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.userByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userByIdErrorReset.toString(),
    });
  });
}
